import * as fromPostPurchaseReducers from './PostPurchaseReducers';
const getResponseState = (state) => ({
  settings: state.settings,
  postPurchase: fromPostPurchaseReducers.getResponseState(state.postPurchase),
});

const getLinksState = (state) => {
  const {
    settings,
    pageState,
    finalizePurchase: { totalAmountFormatted, selectedPaymentMode },
    offerDetails: { title },
    initializePurchase: { form: { errors: initializePurchaseFormErrors } = {} } = {},
    finalizePurchase: { errors: finalizePurchaseFormErrors },
  } = state;

  return {
    settings,
    totalAmountFormatted,
    pageState,
    title,
    initializePurchaseFormErrors,
    finalizePurchaseFormErrors,
    selectedPaymentMode,
  };
};

const getProductsState = (state) => {
  const {
    settings,
    pageState,
    finalizePurchase: { totalAmountFormatted, selectedPaymentMode },
    offerDetails: { title, preview },
    initializePurchase: { form: { errors: initializePurchaseFormErrors } = {} } = {},
    refinePurchase: { form: { errors: refinePurchaseFormErrors } = {} } = {},
    finalizePurchase: { errors: finalizePurchaseFormErrors },
  } = state;

  return {
    settings,
    totalAmountFormatted,
    pageState,
    title,
    preview,
    initializePurchaseFormErrors,
    refinePurchaseFormErrors,
    finalizePurchaseFormErrors,
    selectedPaymentMode,
  };
};

const getInstapayState = (state) => {
  const {
    settings,
    pageState,
    offerDetails: { title },
    finalizePurchase: {
      totalAmountFormatted,
      errors: finalizePurchaseFormErrors,
      selectedPaymentMode,
    },
  } = state;

  return {
    settings,
    title,
    totalAmountFormatted,
    pageState,
    finalizePurchaseFormErrors,
    selectedPaymentMode,
  };
};

export const getPaymentsState = (state) => {
  const { settings: { isRetrying } = {} } = state;
  state = isRetrying ? state.retry : state;
  if (!state.settings) {
    throw new Error('Cannot initialize payments without Settings Reducer');
  }
  if (state.settings.isPaymentResponse) {
    return getResponseState(state);
  }
  else if (state.settings.isLinkPayment) {
    return getLinksState(state);
  }
  else if (state.settings.isInstapayPayment) {
    return getInstapayState(state);
  }
  return getProductsState(state);
};



// WEBPACK FOOTER //
// ./src/payments/reducers/index.js